import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { adminRoutes } from './admin/paneladmin/admin.routes';
import { clientRoutes } from './client/panelclient/client.routes';
import { LOCALE_ID } from '@angular/core';


import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync('animations'),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    {
      provide: LOCALE_ID, useValue: 'pt-BR'
    },
    provideRouter(routes), provideRouter(adminRoutes), provideRouter(clientRoutes),
    provideHttpClient()
  ]
};
